import BugsnagPerformance from "@bugsnag/browser-performance"
import Bugsnag from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import App from "./App.tsx"
import { SelectionProvider } from "./app/department-context.tsx"
import { store } from "./app/store"
import { ErrorScreen } from "./features/home/error-screen.tsx"
import "./index.css"

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_KEY,
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ["production"],
})
BugsnagPerformance.start({ apiKey: import.meta.env.VITE_BUGSNAG_KEY, enabledReleaseStages: ["production"] })
// declare global {
//   interface Window {

//   }
// }
const ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React)

const container = document.getElementById("root")

if (container) {
  const root = createRoot(container)

  root.render(
    <ErrorBoundary FallbackComponent={ErrorScreen}>
      <React.StrictMode>
        <Provider store={store}>
          <SelectionProvider>
            <ToastContainer />
            <App />
          </SelectionProvider>
        </Provider>
      </React.StrictMode>
    </ErrorBoundary>,
  )
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}
